import React, { useState, useEffect } from 'react';
import AuthService from 'src/utils/auth.service';
import {
  Dropdown,
  MenuItem,
} from "react-bootstrap";
import * as XLSX from 'xlsx';
import PlaceholderEmptyMessage from 'src/components/placeholderEmptyMessage';

import _ from 'lodash';
import cx from 'classnames';
import styles from "./assetViewer.module.scss";
import AssetService from 'src/utils/asset.service';

const PromoteContentEmptyMessage = '/images/emailTemplateEmptyMessage.svg'

const ExcelViewer = (props) => {
  const [workbook, setWorkbook] = useState(null);
  const [selectedSheet, setSelectedSheet] = useState("");
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if(_.get(workbook, 'SheetNames')){
      setSelectedSheet(workbook.SheetNames[0]);
      fetchSheetData(workbook.SheetNames[0]);
    }
  }, [workbook])

  useEffect(() => {
    const url = AuthService.getURL(`api/2.0/assets/${props.asset.id}/download`, {
      modifiedDate: AssetService.getNumericValue(props, "asset.metadata.modified_date"),
      preview: true,
      _: new Date().getTime()
    });

    fetchFile(url);
  }, []);

  const fetchWorkbook = (blob) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target.result;
      const wb = XLSX.read(data, { type: 'binary' });
      setWorkbook(wb);
    };
    reader.readAsArrayBuffer(blob);
  };

  const fetchFile = (url) => {
    return fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        fetchWorkbook(blob);
      })
      .catch((error) => {
        console.error('Error fetching file:', error);
      });
  };

  const fetchSheetData = (sheetName) => {
    const ws = workbook.Sheets[sheetName];
    try{
    const sheetsHTML = XLSX.utils.sheet_to_html(ws);
    let tableContainer = document.getElementById("tableContainer");
    tableContainer.innerHTML = sheetsHTML;
    setError(null);
    }catch(e){
      console.error("Error fetching sheet data", e);
      setError(e)
    //   tableContainer.innerHTML = "";
    }

    setSelectedSheet(sheetName);
  };

  const handleSheetChange = (sheetName) => {
    fetchSheetData(sheetName);
  };

  return (
    <div>
      {workbook ? (
        <div>
          <div className={styles.dropdownContainer}>
            <Dropdown
              id={123}
              rootCloseEvent="click"
              className={styles.dropdown}
              open={open}
              onToggle={() => {
                setOpen(!open);
              }}
              direction="down"
            >
              <Dropdown.Toggle className={styles.action}>
                <span className={styles.selectedSheet}>{selectedSheet}</span>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {workbook.SheetNames.map((sheetName, index) => {
                  const active = selectedSheet == sheetName;
                  return (
                    <Dropdown.Item key={index} 
                    active={active}
                    onClick={() => handleSheetChange(sheetName)}
                    >{sheetName}</Dropdown.Item>
                  )
                }
                )}
              </Dropdown.Menu>
            </Dropdown>
          </div>
          {error && (
            <PlaceholderEmptyMessage
              title={"Empty sheet"}
              messageElement={"Even the best sheets start blank. <br/> Add your data and come back to watch it come to life!"}
              image={PromoteContentEmptyMessage}
              className={styles.noAccess}
              visible={true}
              />
          )}
          <div id={"tableContainer"} className={cx(styles.tableContainer, {
            [styles.hideTable] : error
          })}>
          </div>
        </div>
      ) : (
        <div className={styles.loadingSheet}>Loading...</div>
      )}
    </div>
  )
};

export default ExcelViewer;
